module.exports = __webpack_public_path__ + "img/img-shipin-s1-tuya.a74a27aa.png";